import {
    useTopMenuStore,
    useUiLayoutStore,
} from '@frontend/stores'
import clsx from 'clsx'
import {FadeSwitch} from 'swayok-react-mdb-ui-kit/components/Animation/FadeSwitch'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {CabinetButtons} from './CabinetButtons'
import {CabinetLinks} from './CabinetLinks'
import {PublicLinks} from './PublicLinks'
import {TopNavigationCreateAdButton} from './TopNavigationCreateAdButton'
import {TopNavigationLogo} from './TopNavigationLogo'

// Верхнее меню навигации для больших экранов.
export function TopNavigationDesktop() {

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const deviceType = useUiLayoutStore(
        state => state.deviceType
    )

    const cabinetMode = useTopMenuStore(
        state => state.cabinetMode
    )
    const authBlock = useTopMenuStore(
        state => state.authBlock
    )
    const createAdButton = useTopMenuStore(
        state => state.createAdButton
    )
    const wrapInCard = useTopMenuStore(
        state => state.wrapInCard
    )

    return (
        <div
            className={clsx(
                'inner-container flex-row-between',
                cabinetMode ? 'cabinet-mode' : 'public-mode'
            )}
        >
            <div className="flex-row-center justify-content-start flex-1">
                <TopNavigationLogo
                    // Скрываем подпись для небольших компьютерных/планшетных экранов.
                    showLabel={bootstrapSize !== 'lg'}
                />

                <FadeSwitch transitionKey={cabinetMode}>
                    {cabinetMode ? (
                        <CabinetLinks />
                    ) : (
                        <PublicLinks />
                    )}
                </FadeSwitch>
            </div>
            <CabinetButtons
                noLabels={deviceType !== 'desktop'}
            />
            <Collapse
                horizontal
                show={
                    createAdButton
                    && (authBlock || cabinetMode)
                }
                showImmediately
            >
                <div className="ps-4">
                    <TopNavigationCreateAdButton
                        forMobile={false}
                        wrappedInCard={wrapInCard}
                    />
                </div>
            </Collapse>
        </div>
    )
}
